import Icon from './Icon';
import './style/Toast.css';
import React from 'react';
import Positive from '../../media/check-circle@3x.png';
import Negative from '../../media/info-circle@3x.png';
import { Text } from '@harperai/materialize-design-system';

const Toast = ({ index, message, type = "system", state = "neutral" }) => {
    return (
        <div className={`keystone-toast flex fit-content h-gap-s ${type === "user" && "user"} ${state}`}>
            {state !== "neutral" && (
                <Icon icon={state === "positive" ? Positive : Negative} size={16} color="white" />
            )}
            <Text bold={true} variant="white">{message}</Text>
        </div>
    );
};

export default React.memo(Toast);